import { CreateGUFNewLicenceTask, EditGUFNewLicenceTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGufLibraryFields } from "./guf-schema-library";

const sharedTitle = (type: FormType | undefined) => `GUF Nieuwe vergunning ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GUF nieuwe vergunning formulier. ${getDocsLinkMarkdown(
  "GUF"
)}`;

const sharedSourcedocumentData = {
  type: "object" as const,
  title: "Brondocumentgegevens",
  required: [
    "startTime",
    "identificationLicence",
    "legalType",
    "primaryUsageType",
    "humanConsumption",
  ],
  properties: {
    ...pickGufLibraryFields([
      "startTime",
      "identificationLicence",
      "legalType",
      "primaryUsageType",
      "secondaryUsageTypes",
      "humanConsumption",
      "licensedQuantities",
      "designInstallations",
    ]),
  },
};

const getGufNewLicenceCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<CreateGUFNewLicenceTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: ["projectNumber", "deliveryAccountableParty", "qualityRegime", "broId"],
      properties: pickGufLibraryFields([
        "projectNumber",
        "qualityRegime",
        "deliveryAccountableParty",
        "broId",
      ]),
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

const getGufNewLicenceEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGUFNewLicenceTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      title: "Metadata",
      required: [
        "projectNumber",
        "deliveryAccountableParty",
        "qualityRegime",
        "broId",
        "correctionReason",
      ],
      properties: {
        ...pickGufLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGufLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    sourcedocumentData: sharedSourcedocumentData,
  },
});

export function getGufNewLicenceSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGUFNewLicenceTask>;
export function getGufNewLicenceSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<CreateGUFNewLicenceTask>;
export function getGufNewLicenceSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditGUFNewLicenceTask> | SchemaForFormData<CreateGUFNewLicenceTask>;
export function getGufNewLicenceSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing ? getGufNewLicenceEditSchema(type) : getGufNewLicenceCreateSchema(type);
}
